import * as React from 'react';
import { List, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import NavItem from './NavItem';

const Navigation: React.FC = () => {
  const { t } = useTranslation('nav');
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));
  const contactName = isSmall ? 't.contactsShort' : 't.contacts';

  return (
    <List
      component="nav"
      sx={(theme) => ({
        ...theme.mixins.toolbar,
        padding: 0,
        display: 'flex',
      })}
    >
      <NavItem to="/" name={t('t.dashboard')} key="dashboard" exact />
      <NavItem to="/users" name={t('t.users')} key="users" exact />
      <NavItem to="/storages" name={t('t.storages')} key="storages" exact />
      <NavItem to="/products" name={t('t.products')} key="products" exact />
      <NavItem
        to="/applicationlinks"
        name={t('t.applicationlinks')}
        key="applicationlinks"
        exact
      />
    </List>
  );
};

export default Navigation;
